import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    ViewContainerRef
} from '@angular/core';
import { BoardCard } from '@fry/boards/lib';

@Component({
    selector: 'eas-board-card-renderer',
    template: '',
    imports: [],
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoardCardRendererComponent implements OnInit {

    @Input({ required: true }) card!: BoardCard;

    constructor(private viewContainer: ViewContainerRef) {}

    ngOnInit() {
        const component = this.viewContainer.createComponent(this.card.type.viewComponent);
        component.setInput('card', this.card);
    }
}